import React from 'react';

function ClipModalCancel({setOpenCancelModal, setOpenClipModal}) {
    return (
        <div className="h-40 flex flex-col items-center w-80 inline-block bg-gradient-to-b from-zinc-800 to-custom-black shadow-2xl rounded-xl mx-2">
          <div className="w-10/12 flex flex-col justify-around h-40">
            <div className="text-white">
              Discard this clip?
            </div>
            <div className="text-zinc-500">
              If you do you'll lose all your changes
            </div>
            <div className="flex justify-end">
              <div
                className="text-zinc-400 hover:text-zinc-300 cursor-pointer mr-4"
                onClick={() => {
                  setOpenCancelModal(false);
                  setOpenClipModal(false);
                }}
              >
                Discard clip
              </div>
              <div className="text-blue-400 hover:text-blue-300 cursor-pointer"
                onClick={() => {
                  setOpenCancelModal(false);
                }}
              >
                Keep
              </div>
            </div>
          </div>
        </div>
    );
}

export default ClipModalCancel;
